export const isAuthSelector = (state) => state.authentication.isAuthApp;